import { GameManager } from "./gameManager";

declare global {
	interface Window {
		isMobile: boolean;
		aX: number;
	}
}

// Resize for centering of canvas
function doResize(): void {
	const canvasStyle: HTMLElement | null = document.getElementById(
		"canvas-style"
	);

	if (canvasStyle) {
		if (window.innerWidth / window.innerHeight < 640 / 960) {
			canvasStyle.innerHTML = "canvas { width: 100vw; }";
		} else {
			canvasStyle.innerHTML = "canvas { height: 100vh; }";
		}
	}
}

function onLoad(): void {
	GameManager.init();
	doResize();
}

window.addEventListener("load", onLoad);
window.addEventListener("resize", doResize);

// Check if mobile
if (
	typeof window.orientation !== "undefined" ||
	navigator.userAgent.indexOf("IEMobile") !== -1
) {
	window.isMobile = true;
} else {
	window.isMobile = false;
}

/*
function clickRequestDeviceMotionEvent(): void {
    window.DeviceOrientationEvent.requestPermission()
        .then((response) => {
            if (response === "granted") {
                // Error???
                window.addEventListener("deviceorientation", (event) => {
                    if (event.gamma) {
                        window.aX = event.gamma;
                    }
                    const banner = document.getElementById("banner");

                    if (banner) {
                        banner.style.display = "none";
                    }
                });
            } else {
                // Permissions not granted.
            }
        })
        .catch((e) => {
            console.error(e);
        });
}

if (
    window.DeviceMotionEvent
  && typeof window.DeviceMotionEvent.requestPermission === "function"
) {
    // Everything here is just a lazy banner. You can do the banner your way.
    const banner = document.createElement("div");

    banner.innerHTML = `<div id="banner" style="z-index: 1; position: absolute; width: 100%;">`;
    banner.innerHTML += `<p style="padding: 10px">Click here to enable DeviceMotion</p></div>`;
    banner.onclick = clickRequestDeviceMotionEvent;

    const body = document.querySelector("body");

    if (body) {
        body.appendChild(banner);
    }
} else {
    window.aX = 0;
}
*/
